import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  imports: [CommonModule],
})
export class FooterComponent {
  public socialMediaLinks = {
    linkedin: 'https://www.linkedin.com/company/superlawyer/',
    website: 'https://www.superlawyer.in',
    instagram: 'https://www.instagram.com/super.lawyer/',
    youtube: 'https://www.youtube.com/channel/UCIdU1fAe1gmPguWuVStcPpg'
  };

  constructor(private router: Router) {}

  /**
   * Navigate to route and scroll to top
   * @param route - The route to navigate to
   */
  navigateToRoute(route: string): void {
    // Scroll to top first
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });

    // Navigate to the route
    this.router.navigate([route]);
  }
}
